import { render, staticRenderFns } from "./DocumentsNewsBlockControl.vue?vue&type=template&id=34064922&"
import script from "./DocumentsNewsBlockControl.vue?vue&type=script&lang=js&"
export * from "./DocumentsNewsBlockControl.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsNewsBlockControl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports